import { render, staticRenderFns } from "./ServiceListTableComponent.vue?vue&type=template&id=0f35134b&scoped=true"
import script from "./ServiceListTableComponent.vue?vue&type=script&lang=js"
export * from "./ServiceListTableComponent.vue?vue&type=script&lang=js"
import style0 from "./ServiceListTableComponent.vue?vue&type=style&index=0&id=0f35134b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f35134b",
  null
  
)

export default component.exports